import { jsPDF } from 'jspdf';
import QRCode from 'qrcode';
import { formatCurrency } from './orderStorage';

const loadImageData = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const downloadOrderReceipt = async (order) => {
  if (!order.deliveryToken) {
    throw new Error('The delivery pass is still being prepared.');
  }

  const verificationUrl = `${window.location.origin}/verify?token=${encodeURIComponent(order.deliveryToken)}`;
  const [productImage, qrCode] = await Promise.all([
    loadImageData('/images/MF0A9700-2.jpg'),
    QRCode.toDataURL(verificationUrl, {
      width: 600,
      margin: 1,
      color: { dark: '#10271e', light: '#f2ecdd' },
      errorCorrectionLevel: 'H',
    }),
  ]);

  const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
  const cream = [242, 236, 221];
  const forest = [16, 39, 30];
  const gold = [197, 161, 90];

  pdf.setFillColor(...forest);
  pdf.rect(0, 0, 210, 297, 'F');
  pdf.addImage(productImage, 'JPEG', 0, 0, 210, 76);
  pdf.setFillColor(9, 11, 10);
  pdf.setGState(new pdf.GState({ opacity: 0.35 }));
  pdf.rect(0, 0, 210, 76, 'F');
  pdf.setGState(new pdf.GState({ opacity: 1 }));

  pdf.setDrawColor(...gold);
  pdf.setLineWidth(0.6);
  pdf.circle(24, 22, 10);
  pdf.setTextColor(...cream);
  pdf.setFont('times', 'normal');
  pdf.setFontSize(20);
  pdf.text('M', 24, 25, { align: 'center' });
  pdf.setFontSize(10);
  pdf.setTextColor(...gold);
  pdf.text('MUKWEI GIN', 39, 20);
  pdf.setFontSize(7);
  pdf.text('INAUGURAL RELEASE', 39, 25);

  pdf.setFontSize(9);
  pdf.text('PAID ORDER RECEIPT', 186, 20, { align: 'right' });
  pdf.setTextColor(...cream);
  pdf.setFontSize(11);
  pdf.text(order.id, 186, 26, { align: 'right' });

  pdf.setFillColor(242, 236, 221);
  pdf.roundedRect(14, 62, 182, 215, 2, 2, 'F');
  pdf.setTextColor(...forest);
  pdf.setFont('times', 'normal');
  pdf.setFontSize(29);
  pdf.text('Your bottle is reserved.', 26, 89);
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(9);
  pdf.setTextColor(82, 96, 87);
  pdf.text(`This receipt confirms that ${order.fullName} placed and paid for the order below.`, 26, 99);

  const rows = [
    ['Reserved for', order.fullName],
    ['Order reference', order.id],
    ['Quantity', `${order.quantity} bottle${order.quantity === 1 ? '' : 's'}`],
    ['Subtotal', formatCurrency(order.subtotal)],
    ['Delivery', order.shipping ? formatCurrency(order.shipping) : 'Complimentary'],
    ['Total paid', formatCurrency(order.total)],
  ];

  let y = 116;
  rows.forEach(([label, value], index) => {
    pdf.setDrawColor(201, 193, 175);
    pdf.line(26, y + 7, 184, y + 7);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(index === rows.length - 1 ? 10 : 8);
    pdf.setTextColor(100, 107, 101);
    pdf.text(label.toUpperCase(), 26, y);
    pdf.setFont(index === rows.length - 1 ? 'times' : 'helvetica', index === rows.length - 1 ? 'bold' : 'normal');
    pdf.setFontSize(index === rows.length - 1 ? 15 : 9);
    pdf.setTextColor(...forest);
    pdf.text(String(value), 184, y, { align: 'right' });
    y += 14;
  });

  pdf.addImage(qrCode, 'PNG', 26, 205, 48, 48);
  pdf.setFont('times', 'normal');
  pdf.setFontSize(17);
  pdf.setTextColor(...forest);
  pdf.text('Delivery pass', 84, 219);
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(8);
  pdf.setTextColor(92, 101, 94);
  pdf.text('Present this QR code when your order is delivered.', 84, 227);
  pdf.text('The code verifies the paid order directly with Mukwei Gin.', 84, 233);
  pdf.setFontSize(7);
  pdf.text('Not for sale to persons under the age of 18. Please enjoy responsibly.', 84, 244);

  pdf.setDrawColor(...gold);
  pdf.line(26, 261, 184, 261);
  pdf.setFontSize(6.5);
  pdf.setTextColor(102, 105, 99);
  pdf.text(
    'Mukwei Gins (Pty) Ltd is the seller responsible for payment, delivery and fulfilment.',
    105,
    268,
    { align: 'center' }
  );
  pdf.text('Phanda Studios provides hosting and web development services only.', 105, 273, { align: 'center' });

  pdf.save(`Mukwei-Receipt-${order.id}.pdf`);
};
